module.exports = __webpack_public_path__ + "static/img/home_banner4.9c2ca31a.png";